export default __webpack_public_path__ + "static/media/Bankscreen-Rewards.72eedfe1.png";